//import Vue from 'vue'
import axios from "axios";
//import general from "./menuitems";
import menuitems from "./menuitems";
import Swal from "sweetalert2";

export default {
  namespaced: true,
  state: {
    urlApi:
      process.env.VUE_APP_NODE_ENV === "production"
        ? process.env.VUE_APP_API_URL_PROD
        : process.env.VUE_APP_API_URL_DEVEL,
    drawer: true,
    loadingBtn: false,
    dialog: false,
    loadingBtn2: false,
    url: "",
    user: null,
    pass: null,
    overlay: false,
    loadingTable: false,
    token: null,
    alertas: "",
    urlExternal: null,
    titleToolbar: "PORTAL SIGLOBPO",
    count: 1,
    menu: [],
    months: [
      { number: "01", name: "Enero" },
      { number: "02", name: "Febrero" },
      { number: "03", name: "Marzo" },
      { number: "04", name: "Abril" },
      { number: "05", name: "Mayo" },
      { number: "06", name: "Junio" },
      { number: "07", name: "Julio" },
      { number: "08", name: "Agosto" },
      { number: "09", name: "Septiembre" },
      { number: "10", name: "Octubre" },
      { number: "11", name: "Noviembre" },
      { number: "12", name: "Diciembre" },
    ],

    sweetAlert: {
      title: "Éxito",
      html: "",
      icon: "success",
      toast: true,
      timer: 5000,
      confirmButtonText:
        '<span class="mdi mdi-close-circle-outline"></span> Cerrar',
      timerProgressBar: true,
      position: "top",
      confirmButtonColor: "#a5dc86",
    },
    /*paramAlertQuestion: {
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Aceptar!",
    },*/

    requiredRule: [(v) => !!v || "El campo es obligatorio"],
  },
  mutations: {
    setCount(state, payload) {
      state.count = payload;
    },
    setDrawer(state, payload) {
      state.drawer = payload;
    },

    setDialog(state) {
      state.dialog = !state.dialog;
    },

    setLoadingBtn(state, payload) {
      state.loadingBtn = payload;
    },

    setLoadingBtn2(state) {
      state.loadingBtn2 = !state.loadingBtn2;
    },

    sweetAlert(state, payload) {
      if (typeof payload.timer != "undefined")
        state.sweetAlert.timer = payload.timer;

      if (typeof payload.title != "undefined")
        state.sweetAlert.title = payload.title;

      if (typeof payload.icon != "undefined")
        state.sweetAlert.icon = payload.icon;

      if (typeof payload.toast != "undefined")
        state.sweetAlert.toast = payload.toast;

      if (typeof payload.confirmButtonColor != "undefined")
        state.sweetAlert.confirmButtonColor = payload.confirmButtonColor;

      state.sweetAlert.html = payload.html;
    },

    setLoadingTable(state, payload) {
      state.loadingTable = payload;
    },

    setToken(state, payload) {
      state.token = payload;
    },

    setUser(state, payload) {
      state.user = payload;
    },

    setUrl(state, payload) {
      state.url = state.urlApi + payload;
    },

    setOverlay(state, payload) {
      state.overlay = payload;
    },

    setMenu(state) {
      //localStorage.setItem("menu", JSON.stringify(general.state.menu));
      //console.log("user:" + state.user);
      localStorage.setItem("menu", JSON.stringify(menuitems.state.menu));
      //state.menu = JSON.parse(localStorage.getItem('menu'))
      state.menu = menuitems.state.menu;
      /*if (state.user != null) {
        state.menu = general.state.menu.filter((item) => {
          let c = false;
          for (let j = 0; j < state.user.permission.length; j++) {
            if (item.permissions.includes(state.user.permission[j])) {
              c = true;
            }
          }
          return c;
        });
      }
      return false;*/
      // localStorage.setItem("menu", JSON.stringify(general.state.menu));
    },

    setTitleToolbar(state, payload) {
      state.titleToolbar =
        typeof payload == "undefined" ? "PORTAL SIGLOBPO" : payload;
    },
  },
  actions: {
    alertNotification({ commit }, payload) {
      /* commit("setSeewtNotification", {
        html: payload.param.html,
        timer: payload.param.timer,
        title: payload.param.title,
        icon: payload.param.icon,
        toast: payload.param.toast,
        confirmButtonColor: payload.param.confirmButtonColor,
      });*/
      Swal.fire({
        html: payload.param.html,
        timer: payload.param.timer,
        title: payload.param.title,
        icon: payload.param.icon,
        toast: payload.param.toast,
      });
      /*Vue.swal({
        title: state.sweetAlert.title,
        html: state.sweetAlert.html,
        icon: state.sweetAlert.icon,
        toast: state.sweetAlert.toast,
        timerProgressBar: state.sweetAlert.timerProgressBar,
        timer: state.sweetAlert.timer,
        position: state.sweetAlert.position,
        confirmButtonText: state.sweetAlert.confirmButtonText,
        grow: "row",
        confirmButtonColor: state.sweetAlert.confirmButtonColor,
      });*/

      /*commit("setSeewtNotification", {
        title: "Éxito",
        icon: "success",
        toast: true,
        timer: 5000,
        confirmButtonColor: "#a5dc86",
      });*/
    },

    requestApi({ state }, payload) {
      payload.data.user_name =
        state.user == null ? null : state.user.user_login_id;
      payload.data.user_empresa_id =
        state.user == null ? null : state.user.empresa_id;

      let body = { params: payload.data };

      if (
        (payload.method === "PATCH" || payload.method === "PUT") &&
        state.url.split("/").length < 5
      ) {
        body = { data: { data: payload.data } };
      } else if (
        (payload.method === "POST" ||
          payload.method === "DELETE" ||
          payload.method === "PATCH" ||
          payload.method === "PUT") &&
        state.url.split("/").length > 4
      ) {
        body = { data: payload.data };
      } else if (
        payload.method === "POST" ||
        payload.method === "DELETE" ||
        payload.method === "PATCH" ||
        payload.method === "PUT"
      ) {
        body = { data: payload.data };
      }

      return new Promise((resolve, reject) => {
        axios({
          method: payload.method,
          url: state.url,
          ...body,
          headers: {
            Authorization: "Bearer " + state.token,
          },
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
